<template>
  <main class="container poster_wrap">
    <div
      :class="{ s_menban: true, hide: !classifyShow, show: classifyShow }"
      @click="changeClassify"
    ></div>
    <div class="tabs_wrap">
      <div class="sh_tabs">
        <div
          :class="{ t: selectDistrict === 'one' }"
          @click="changeDistrict('one')"
        >
          9.9元包邮
        </div>
        <div
          :class="{ t: selectDistrict === 'two' }"
          @click="changeDistrict('two')"
        >
          本周热卖
        </div>
        <div class="flex">
          <div
            class="series flex"
            :class="{ t_f05c61: classifyShow }"
            @click="changeClassify"
          >
            分类
            <div
              :class="{
                iconfont: true,
                series_icon: true,
                'icon-down-trangle': classifyShow,
                'icon-down-trangle-copy': !classifyShow,
              }"
            ></div>
          </div>
        </div>
      </div>
      <div class="dis_series" v-if="classifyShow">
        <template v-if="seriesDataList.length > 1 && !dataLoading">
          <div
            v-for="(item, index) in seriesDataList"
            :key="index"
            :class="{
              series_item: true,
              active_series: index === currentIndex,
            }"
            @click="selectSeriesItem(index)"
          >
            {{ item }}
          </div>
        </template>
        <segment-line v-else-if="!dataLoading" line-text="无相关分类">
        </segment-line>
        <segment-line v-if="dataLoading" line-text="正在加载" :is-load="true">
        </segment-line>
      </div>
    </div>
    <div class="souhuo_list pad-btm15">
      <souhuo-list
        :data-list="dataList"
        :scroll-disabled="scrollDisabled"
        @loadMore="loadMore"
        @entoDetailPage="entoDetailPage"
        :show-head="false"
      >
      </souhuo-list>
      <!-- no more -->
      <segment-line v-if="!haveMore" line-text="没有更多商品啦"> </segment-line>
      <!-- loading -->
      <segment-line v-if="haveMore" line-text="正在加载" :is-load="true">
      </segment-line>
    </div>
    <!-- 返回顶部 -->
    <quick-top
      @returnTop="returnTop"
      :isReturn="isReturn"
      :positionBtm="20"
    ></quick-top>
  </main>
</template>

<script>
import {
  onePackage,
  noLoginOnePackage,
  Leve2NameList,
  Leve2NameListNoLogin,
  RegionalAmount,
} from "@/api/onePackage";
import SouhuoList from "@/components/puppetComponent/SouhuoList";
import SegmentLine from "@/components/puppetComponent/SegementLine";
import QuickTop from "@/components/smartComponent/QuickTop";
import { Indicator, Toast } from "mint-ui";
export default {
  data() {
    return {
      // 元区，卖得最好
      selectDistrict: "one",
      selectAmount: null,
      isSaleMax: false,
      // 分类
      classifyShow: false,
      seriesDataList: ["全部"],
      currentIndex: 0,
      haveMore: true,
      scrollDisabled: false,
      pageScrollTop: 0,
      dataList: [],
      dataLoading: false,
      isReturn: false,
    };
  },
  components: {
    SouhuoList,
    SegmentLine,
    QuickTop,
  },
  mounted() {
    this.isLogin = this.$store.getters.loginState;
    // RegionalAmount().then(res => {
    //   this.selectAmount = res.Amount1
    //   this.fetchLeveData()
    //   this.fetchData()
    // }).catch(res => {
    //   Toast(res.ErrMsg)
    // })
    // 绑定监听事件
    this.$nextTick(() => {
      this.container = document.getElementsByClassName("container")[0];
      this.container.addEventListener("scroll", this.handleScroll);
    });
  },
  methods: {
    reFetchPage(from) {
      if (from.name === "goodsDetail" && this.container) {
        this.$nextTick(() => {
          this.container.scrollTop = this.pageScrollTop;
        });
      } else {
        this.isLogin = this.$store.getters.loginState;
        this.dataList = [];
        this.dataList.splice(0);
        this.seriesDataList = ["全部"];
        this.seriesDataList.splice(1);
        this.pageScrollTop = 0;
        this.selectDistrict = "one";
        this.selectAmount = null;
        this.isSaleMax = false;
        this.classifyShow = false;
        this.currentIndex = 0;
        this.isReturn = false;
        RegionalAmount()
          .then((res) => {
            this.selectAmount = res.Amount1;
            this.fetchLeveData();
            this.fetchData();
          })
          .catch((res) => {
            if (res.ErrMsg) {
              Toast(res.ErrMsg);
            }
          });
      }
    },
    fetchData(isDropDown = false) {
      Indicator.open({
        text: "加载中",
        spinnerType: "triple-bounce",
      });
      let params = {
        DropDown: isDropDown,
        Amount: this.selectDistrict === "one" ? this.selectAmount : null,
        IsSaleMax: this.isSaleMax,
        Leve2Name:
          this.currentIndex === 0 ? "" : this.seriesDataList[this.currentIndex],
      };
      this.scrollDisabled = true;
      if (this.isLogin) {
        onePackage(params)
          .then((res) => {
            this.dataList = [...this.dataList, ...res.DataList];
            this.isLastOne = res.BoolSID;
            if (res.BoolSID) {
              this.haveMore = false;
            } else {
              this.haveMore = true;
            }
            this.scrollDisabled = false;
            Indicator.close();
          })
          .catch((res) => {
            this.haveMore = false;
            Indicator.close();
            if (res.ErrMsg) {
              Toast(res.ErrMsg);
            }
          });
      } else {
        noLoginOnePackage(params)
          .then((res) => {
            this.dataList = [...this.dataList, ...res.DataList];
            this.isLastOne = res.BoolSID;
            if (res.BoolSID) {
              this.haveMore = false;
            } else {
              this.haveMore = true;
            }
            this.scrollDisabled = false;
            Indicator.close();
          })
          .catch((res) => {
            this.haveMore = false;
            Indicator.close();
            if (res.ErrMsg) {
              Toast(res.ErrMsg);
            }
          });
      }
    },
    fetchLeveData() {
      let params = {
        Amount: this.selectDistrict === "one" ? this.selectAmount : null,
      };
      if (this.isLogin) {
        this.dataLoading = true;
        Leve2NameList(params)
          .then((res) => {
            this.dataLoading = false;
            this.seriesDataList = [
              ...this.seriesDataList,
              ...res.Leve2NameList,
            ];
          })
          .catch((res) => {
            if (res.ErrMsg) {
              Toast(res.ErrMsg);
            }
          });
      } else {
        this.dataLoading = true;
        Leve2NameListNoLogin(params)
          .then((res) => {
            this.dataLoading = false;
            this.seriesDataList = [
              ...this.seriesDataList,
              ...res.Leve2NameList,
            ];
          })
          .catch((res) => {
            if (res.ErrMsg) {
              Toast(res.ErrMsg);
            }
          });
      }
    },
    // 分类切换
    changeClassify() {
      this.classifyShow = !this.classifyShow;
    },
    // 元区，卖得最好
    changeDistrict(val) {
      if (this.selectDistrict !== val) {
        this.dataList = [];
        this.seriesDataList = ["全部"];
        this.haveMore = true;
        this.currentIndex = 0;
        this.classifyShow = false;
        this.selectDistrict = val;
        if (val === "one") {
          this.isSaleMax = false;
        } else {
          this.isSaleMax = true;
        }
        this.fetchLeveData();
        this.fetchData();
      }
    },
    selectSeriesItem(index) {
      if (this.currentIndex !== index) {
        this.dataList = [];
        this.haveMore = true;
        this.currentIndex = index;
        this.classifyShow = false;
        this.fetchData();
      }
    },
    // 进入详情页
    entoDetailPage(productID, isStockNoZero, isFreeCard) {
      this.$router.push({
        name: "goodsDetail",
        query: {
          productID: productID,
          isFreeCard: isFreeCard,
        },
      });
    },
    loadMore() {
      if (this.isLastOne) {
        this.haveMore = false;
        return;
      }
      this.haveMore = true;
      this.fetchData(true);
    },
    // 返回顶部
    returnTop: function () {
      let container = this.container;
      container.scrollTop = 0;
    },
    // 滚动监听
    handleScroll(e) {
      // 滚动高度
      let scrollTop = this.container.scrollTop;
      this.pageScrollTop = scrollTop;
      // 屏幕高度
      let documentH =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (scrollTop > documentH) {
        this.isReturn = true;
      } else {
        this.isReturn = false;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.reFetchPage(from);
    });
  },
};
</script>

<style scoped>
.poster_wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #f5f5f5;
}
.souhuo_list {
  padding-top: 45px;
}
.flex {
  display: flex;
}
.tabs_wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  width: 100%;
  background: #f5f5f5;
}
.sh_tabs {
  box-shadow: 0 4px 6px -1px #eee;
  z-index: 100;
  position: relative;
  color: #666;
  display: flex;
}
.sh_tabs > div {
  flex: 1;
  text-align: center;
  height: 46px;
  line-height: 46px;
  align-items: center;
  position: relative;
  font-size: 14px;
}
.t {
  text-align: center;
  background-color: #fff;
  position: relative;
  color: #f05c61;
  /* font-weight: bold; */
}
.t:before {
  content: "";
  width: 15px;
  height: 45px;
  position: absolute;
  transform: skewX(-10deg);
  background: #fff;
  left: -5px;
  box-shadow: -4px 0px 1px -1px #eee;
}
.t:after {
  content: "";
  width: 15px;
  height: 45px;
  position: absolute;
  transform: skewX(10deg);
  background: #fff;
  right: -5px;
  box-shadow: 3px 0px 1px -1px #eee;
}
.sh_tabs .t:first-child {
  margin: 0;
}
.sh_tabs .t:first-child:before {
  background: #fff;
  height: 0;
}
.series_wrap {
  height: 100%;
  box-sizing: border-box;
  padding-top: 45px;
}
.series {
  border-radius: 45px;
  background: #fff;
  width: 55px;
  height: 23px;
  line-break: 23px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  display: flex;
}
.series_icon {
  margin-top: 2px;
  font-size: 12px;
}
.series.t_f05c61 {
  color: #f05c61;
}
.res-series {
  position: relative;
}
.dis_series {
  position: absolute;
  top: 46px;
  width: 100%;
  background: #fff;
  left: 0;
  padding: 10px;
  z-index: 99;
  overflow: hidden;
  font-size: 14px;
  box-sizing: border-box;
}
.dis_series .series_item {
  padding: 4px 15px;
  margin: 8px;
  display: inline-block;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 3px;
}
.active_series {
  border: 1px solid #f05c61 !important;
  color: #f05c61;
}
.s_menban {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 9;
  background: #000;
  opacity: 0.3;
}
.hide {
  display: none;
}
.show {
  display: block;
}
</style>
